import React from "react";
import { Button, Form, FormGroup, Input, Label, Alert, Row, Col } from "reactstrap";
import axios from "axios";
import { API_URL_SEDE_SUBCATS } from "../../constants";
import { getAuthHeaders } from "../../utils/auth";

export default class NewSubcategoryForm extends React.Component {
  state = {
    name: "",
    code: "",
    is_active: true,
    error: "",
    success: "",
    loading: false,
  };

  onChange = (e) => {
    const { name, value, type, checked } = e.target;
    let v = type === "checkbox" ? checked : value;
    if (name === "code") v = (v || "").toUpperCase();
    this.setState({ [name]: v, error: "", success: "" });
  };

  onSubmit = async (e) => {
    e.preventDefault();
    const { sedeId, onCreated } = this.props;
    const { name, code, is_active } = this.state;
    if (!sedeId) {
      this.setState({ error: "Sede inválida." });
      return;
    }
    if (!name.trim()) {
      this.setState({ error: "El nombre es requerido." });
      return;
    }

    this.setState({ loading: true, error: "", success: "" });
    try {
      const headers = getAuthHeaders();
      await axios.post(
        API_URL_SEDE_SUBCATS,
        { sede: sedeId, name: name.trim(), code: code.trim().toUpperCase() || undefined, is_active },
        { headers }
      );
      this.setState({ name: "", code: "", is_active: true, success: "Subcategoría creada." });
      onCreated?.(); // parent will refresh list
    } catch (err) {
      console.log(err);
      this.setState({ error: "No se pudo crear la subcategoría." });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { name, code, is_active, error, success, loading } = this.state;
    return (
      <Form onSubmit={this.onSubmit}>
        <Row className="g-2">
          <Col md={6}>
            <FormGroup>
              <Label>Nombre</Label>
              <Input name="name" value={name} onChange={this.onChange} placeholder="General" />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>Código (opcional)</Label>
              <Input name="code" value={code} onChange={this.onChange} placeholder="GEN" maxLength={8} />
            </FormGroup>
          </Col>
          <Col md={3} className="d-flex align-items-end">
            <FormGroup check className="mb-3">
              <Input type="checkbox" id="is_active" name="is_active" checked={is_active} onChange={this.onChange} />
              <Label for="is_active" check className="ms-2">Activa</Label>
            </FormGroup>
          </Col>
        </Row>

        {error && <Alert color="danger">{error}</Alert>}
        {success && <Alert color="success">{success}</Alert>}

        <Button color="secondary" disabled={loading}>
          {loading ? "Agregando..." : "Agregar subcategoría"}
        </Button>
      </Form>
    );
  }
}